import { Typography } from '@capsule/consumer-design-system';

import InlineSVG from 'svg-inline-react';

import CheckCircleIcon from 'public/check-circle-icon.svg';
import Marker from 'public/marker-dark.svg';
import { Skeleton } from 'src/app/components/Elements/Skeleton';

import { PharmacySearchMap } from './PharmacySearchMap';
import {
  CheckIconContainer,
  ListContainer,
  ListItem,
  ListSubText,
  ListTextContainer,
  MapContainerParent,
  PlaceIconContainer,
} from './styles';

const toggleOptions = {
  MAP: 'MAP',
  LIST: 'LIST',
};

const SearchResultsViewRenderer = ({
  selectedPharmacy,
  selectItem,
  selectNonSearchItem,
  isFetchingNearby,
  nearbyPlaces,
  isNewEntry,
  searchProps,
  textInputRef,
  displayProps,
}) => {
  const onSearchThisArea = (center: string, radius: number) => {
    const fetchPharmacy = async () => {
      await searchProps.refetch();
    };
    textInputRef.current.value = selectedPharmacy.name || '';
    searchProps.setRadius(radius);
    searchProps.setLocation(center);
    fetchPharmacy();
  };
  return (
    <>
      {selectedPharmacy && (
        <MapContainerParent
          toggleShow={displayProps.visualization === toggleOptions.MAP}
          hasParentForm={displayProps.hasParentForm}
        >
          <PharmacySearchMap
            selectedPharmacy={selectedPharmacy}
            selectItem={selectItem}
            toggleShow={displayProps.visualization === toggleOptions.MAP}
            onSearchThisArea={onSearchThisArea}
            nearbyPlaces={nearbyPlaces}
          />
        </MapContainerParent>
      )}
      {isFetchingNearby ? (
        <Skeleton />
      ) : (
        <ListContainer
          toggleShow={displayProps.visualization === toggleOptions.LIST}
          isFullScreen={displayProps.isFullScreen}
          hasParentForm={displayProps.hasParentForm}
          role="listbox"
          as="ul"
        >
          {[
            !isNewEntry
              ? nearbyPlaces?.map(item => {
                  const isSelected = item.place_id === selectedPharmacy?.place_id;
                  return (
                    <ListItem
                      isSelected={isSelected}
                      role="button"
                      key={`list-item-${item.place_id}`}
                      onClick={() => {
                        selectItem(item);

                        displayProps.setVisualization(toggleOptions.MAP);
                      }}
                    >
                      <PlaceIconContainer aria-hidden>
                        <InlineSVG src={Marker} />
                      </PlaceIconContainer>
                      <ListTextContainer>
                        <Typography variant="body">{item.name}</Typography>
                        <ListSubText>
                          <Typography variant="small">{item.formatted_address}</Typography>
                        </ListSubText>
                      </ListTextContainer>
                      <CheckIconContainer aria-hidden>
                        {isSelected && <InlineSVG src={CheckCircleIcon} />}
                      </CheckIconContainer>
                    </ListItem>
                  );
                })
              : null,
            textInputRef.current?.value?.length > 0 && (
              <ListItem
                isSelected={isNewEntry}
                key={`list-item-new-entry`}
                onClick={() => selectNonSearchItem({ name: textInputRef.current.value })}
              >
                <PlaceIconContainer>
                  <InlineSVG src={Marker} />
                </PlaceIconContainer>
                <ListTextContainer>
                  <Typography variant="body">"{textInputRef.current.value}"</Typography>
                  <ListSubText>
                    <Typography variant="small">Use this name</Typography>
                  </ListSubText>
                </ListTextContainer>
                <CheckIconContainer>{isNewEntry && <InlineSVG src={CheckCircleIcon} />}</CheckIconContainer>
              </ListItem>
            ),
          ]}
        </ListContainer>
      )}
    </>
  );
};

export const SearchResultsView = SearchResultsViewRenderer;
